/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Links_Delete_ConfirmInputs */

const cs_links_delete_confirm = /** @type {(inputs: Links_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat odkaz „${i?.name}“?`)
};

const en_links_delete_confirm = /** @type {(inputs: Links_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete link “${i?.name}”?`)
};

/**
* | output |
* | --- |
* | "Delete link “{name}”?" |
*
* @param {Links_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_delete_confirm = /** @type {((inputs: Links_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_delete_confirm(inputs)
	return cs_links_delete_confirm(inputs)
});